import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { X, GitCompare } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CompareBar() {
  const { compare, toggleCompare, clearCompare } = useApp();
  const [products, setProducts] = useState([]);
  const loc = useLocation();

  useEffect(() => {
    if (compare.length === 0) { setProducts([]); return; }
    api.get("/products", { params: { limit: 200 } }).then((r) => {
      setProducts(r.data.filter((p) => compare.includes(p.id)));
    });
  }, [compare]);

  if (compare.length === 0 || loc.pathname === "/comparar") return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 rounded-2xl border border-border bg-background/90 backdrop-blur-xl shadow-2xl p-3 flex items-center gap-3 max-w-[95vw]" data-testid="compare-bar">
      <GitCompare className="w-4 h-4 text-primary shrink-0" />
      <div className="flex items-center gap-2 overflow-x-auto">
        {products.map((p) => (
          <div key={p.id} className="flex items-center gap-1.5 rounded-full bg-secondary pl-1 pr-2 py-1" data-testid={`compare-chip-${p.slug}`}>
            <img src={p.image} alt="" className="w-6 h-6 rounded-full object-cover" />
            <span className="text-xs font-medium max-w-[100px] truncate">{p.name}</span>
            <button onClick={() => toggleCompare(p.id)} className="ml-1 opacity-60 hover:opacity-100"><X className="w-3 h-3" /></button>
          </div>
        ))}
      </div>
      <Button asChild size="sm" className="rounded-full btn-primary" data-testid="compare-open-btn">
        <Link to="/comparar">Comparar ({compare.length})</Link>
      </Button>
      <Button variant="ghost" size="sm" onClick={clearCompare} className="text-xs" data-testid="compare-clear-btn">Limpar</Button>
    </div>
  );
}
